import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'

export const Co2Emissions = withFacetContext(
    FacetName.co2_emission_values,
    withFilterContext(FilterName.co2_emission_values, SearchFiltersDropdown, {
        title: 'CO2 emissions',
        hideLabel: true,
    })
)
